import styled from "styled-components";
import colors from "@streeteasy/design-system/deprecated/colors";

const CalendarOptionContainer = styled.a`
  align-items: center;
  display: flex;
  margin: 0 -16px 0 -16px;
  padding: 7px;

  &:hover {
    background-color: ${colors.mouseGrey};
  }
`;

const Icon = styled.i`
  color: ${colors.primary};
  margin-right: 10px;
`;

Icon.displayName = "Icon";

export { CalendarOptionContainer, Icon };
